import request from 'api/request';

export default function activateCourse(id) {
  return request({ url: `/courses/${id}/activate`, method: 'POST' });
}
